import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-chat',
  templateUrl: '../templates/loading_chat.component.html',
  styleUrls: ['../templates/styles/loading_chat.component.css']
})
export class LoadingChatComponent {
  isLoading: boolean = true;

  // Метод для установки состояния загрузки
  setLoading(loading: boolean) {
    this.isLoading = loading;
  }
}
